import { useTheme } from 'emotion-theming'; // @modusign/design-system에서 제공안하지만, Provider는 사용하는 중
import { useMemo } from 'react';

import useLocalStorageSync from '@app/hooks/useLocalStorageSync';
import { AppThemeType } from '@app/theme';

type ColorScheme = 'light' | 'default';

export function useColorScheme() {
  const [colorScheme = 'light', setColorScheme] = useLocalStorageSync<ColorScheme>(
    'modusign-color-scheme',
    'light'
  );

  const theme = useTheme<AppThemeType>();

  return useMemo(
    () => ({
      colorScheme,
      theme: theme[colorScheme],
      toggleColorScheme: (nextColorScheme?: ColorScheme) =>
        setColorScheme(nextColorScheme ?? colorScheme === 'light' ? 'default' : 'light'),
    }),
    [colorScheme, setColorScheme, theme]
  );
}
